import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";
import { Node } from "prosemirror-model";
import { getTipTapSchema } from "../utils/helpers";
import { v4 as uuidv4 } from "uuid";

const defaultTest = Node.fromJSON(getTipTapSchema(), {
  type: "doc",
  content: [
    {
      type: "orderedList",
      attrs: { start: 1 },
      content: [
        {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              attrs: { id: uuidv4() },
              content: [],
            },
          ],
        },
      ],
    },
  ],
});

interface TestEditorPropertiesType {
  originalTestCommands: Node;
  testCommands: Node;
  recordingTitle: string;
  originalRecordingTitle: string;
  hasGeneratedEnrichedLogs: boolean;
}

const testEditorPropertiesAtom = atomWithReset<TestEditorPropertiesType>({
  originalTestCommands: defaultTest,
  testCommands: defaultTest,
  recordingTitle: "Untitled",
  originalRecordingTitle: "",
  hasGeneratedEnrichedLogs: false,
});

// Set by TestEditorGpt when rendered in markdown mode. Other components that
// trigger lambda calls (e.g. the redefine-step dialog) read this so they can
// include the full markdown document as `global_test_task` on every call.
const markdownModeAtom = atom<boolean>(false);

export { testEditorPropertiesAtom, markdownModeAtom };

export type { TestEditorPropertiesType };
